import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { usePortalAuth } from "../../contexts/PortalAuthContext";
import { portalLogout } from "../../services/merchant-portal";
import "./portal.scss";

const navLinkClass = ({ isActive }) =>
  `portal-nav-link${isActive ? " portal-nav-link--active" : ""}`;

const PortalLayout = () => {
  const navigate = useNavigate();
  const { markLoggedOut } = usePortalAuth();

  const handleLogout = () => {
    portalLogout()
      .catch(() => {})
      .finally(() => {
        markLoggedOut();
        toast.info("Logged out");
        navigate("/merchant-portal/login", { replace: true });
      });
  };

  return (
    <div className="portal-shell min-h-screen bg-main-bg dark:bg-main-dark-bg">
      <header className="portal-header bg-white dark:bg-secondary-dark-bg shadow-sm">
        <div className="portal-header-inner">
          <Link to="/merchant-portal/dashboard" className="portal-brand">
            Afta Merchant Portal
          </Link>
          <nav className="portal-nav">
            <NavLink to="/merchant-portal/dashboard" className={navLinkClass}>
              Dashboard
            </NavLink>
            <NavLink to="/merchant-portal/transactions" className={navLinkClass}>
              Transactions
            </NavLink>
            <NavLink to="/merchant-portal/sub-accounts" className={navLinkClass}>
              Sub accounts
            </NavLink>
            <NavLink to="/merchant-portal/settings" className={navLinkClass}>
              Settings
            </NavLink>
          </nav>
          <button type="button" className="portal-logout-btn" onClick={handleLogout}>
            Log out
          </button>
        </div>
      </header>
      <main className="portal-main">
        <Outlet />
      </main>
    </div>
  );
};

export default PortalLayout;
